import React from 'react';

interface ToggleSwitchProps {
  checked: boolean;
  onToggle: () => void;
  enabledLabel?: string;
  disabledLabel?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onToggle,
  enabledLabel = '有効',
  disabledLabel = '無効',
}) => (
  <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none' }}>
    <div
      onClick={onToggle}
      style={{
        width: 40,
        height: 24,
        borderRadius: 12,
        background: checked ? '#1976d2' : '#e0e0e0',
        position: 'relative',
        transition: 'background 0.2s ease',
        cursor: 'pointer',
        flexShrink: 0,
      }}
    >
      <div style={{
        width: checked ? 18 : 12,
        height: checked ? 18 : 12,
        borderRadius: '50%',
        background: checked ? '#fff' : '#9e9e9e',
        position: 'absolute',
        top: '50%',
        left: checked ? 19 : 3,
        transform: 'translateY(-50%)',
        transition: 'all 0.2s ease',
        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
      }} />
    </div>
    <span style={{ fontSize: 13, color: '#666' }}>
      {checked ? enabledLabel : disabledLabel}
    </span>
  </label>
);

export default ToggleSwitch;
